import React from "react";
import { Badge } from "../../../components/ui/badge";

interface RepositoryEditorHeaderProps {
  owner: string;
  repo: string;
  workspaceKey: string;
  branch: string;
}

const RepositoryEditorHeader = ({
  owner,
  repo,
  workspaceKey,
  branch,
}: RepositoryEditorHeaderProps) => {
  return (
    <div className="space-y-2 rounded-md border p-4">
      <div>
        <h2 className="text-lg font-semibold tracking-tight">Localization editor</h2>
        <p className="text-xs text-muted-foreground">
          {owner}/{repo}
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Badge variant="outline">Workspace: {workspaceKey}</Badge>
        <Badge variant="outline">Branch: {branch || "auto"}</Badge>
      </div>
    </div>
  );
};

export default RepositoryEditorHeader;
